// @ts-ignore
import Aegis from 'aegis-web-sdk';
import { getEnvName } from './opentelemetry';

const env = getEnvName();

let id = 'XykOPVSLrVwSudALou';

if (env === 'Dev' || env === 'Test') {
  id = 'gNDuPkXH6461GxVxiZ';
}

export const aegis = new Aegis({
  id, // 项目key
  reportApiSpeed: false, // 接口测速
  reportAssetSpeed: false, // 静态资源测速
  spa: false, // spa 页面需要开启，页面切换的时候上报pv
});
